
    
<div class="nsw-container" style="margin-top: 2.5rem;">
    <h2 class="feedback-heading">We'd love to hear from you</h2>
    <p class="feedback-description">
        Please use the form below to ask a question, provide some feedback or if you are interested in joining our program
    </p> 
    <div class="nsw-form"  style="margin-top:16px;max-width: 466px;">
        <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()" autocomplete="off" method="post">
            <div class="nsw-form__group contact-us-form__group" style="margin-top:0px;">
                <fieldset class="nsw-form__fieldset">
                <legend style="display: inherit">
                    <span class="nsw-form__legend">My message is about:</span>
                    <span *ngIf="requiredValidate('option')" class="nsw-form__helper nsw-form__helper--error" id="form-text-3-error-text"><span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>Please select a message type.</span>
                </legend>
                <ng-container *ngFor="let option of contactTypes">
                    <input class="nsw-form__radio-input" id="{{option}}" type="radio" [value]="option" formControlName="option">
                    <label  class="nsw-form__radio-label" for="{{option}}">{{ option }}</label>
                </ng-container>
            </fieldset>
            </div>
            
            <div class="nsw-form__group contact-us-form__group" *ngIf="contactUsForm.get('option')?.value">
                <label for="name" class="nsw-form__label">Write your message here</label>
                <textarea rows="5" class="nsw-form__input" type="textarea" id="message" name="message" formControlName="message"></textarea>
                <span class="nsw-form__helper" id="form-textarea-2-helper-text">Maximum 500 characters</span>
                <span *ngIf="requiredValidate('message')" class="nsw-form__helper nsw-form__helper--error" id="form-text-3-error-text"><span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>Please enter a message to send.</span>
            </div>
            
            <div class="nsw-form__group contact-us-form__group">
              <label for="name" class="nsw-form__label">Name</label>
              <input type="text" class="nsw-form__input" id="name" name="name" formControlName="name">
            </div>
            
            <div class="nsw-form__group contact-us-form__group">
              <label for="email" class="nsw-form__label nsw-form__required">Email<span class="sr-only"> (required)</span></label>
              <input type="email" class="nsw-form__input" id="email" name="email" formControlName="email" required>
              <span *ngIf="requiredValidate('email')" class="nsw-form__helper nsw-form__helper--error" id="form-text-3-error-text"><span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>Please enter an email address.</span>
              <span *ngIf="emailValidate('email')" class="nsw-form__helper nsw-form__helper--error" id="form-text-3-error-text"><span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>Please enter a valid email address.</span>
            </div>
            
            <div class="nsw-form__group contact-us-form__group">
              <label for="mobile" class="nsw-form__label">Mobile</label>
              <input type="text" class="nsw-form__input" id="mobile" name="mobile" formControlName="mobile">
            </div>
            
            
            <div class="nsw-form__group contact-us-form__group" style="margin-top:42px;">
                <button type="button" (click)="onCancel()" class="nsw-button nsw-button--dark-outline-solid" style="margin-right:16px">Cancel</button>
                <button type="submit" class="nsw-button nsw-button--dark">Submit</button>
                <span *ngIf="showFormSuccess" class="nsw-form__helper nsw-form__helper--valid" id="form-textarea-4-valid-text"><span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">check_circle</span>Thank you for your message. We will be in touch shortly.</span>
                <span *ngIf="showFormError" class="nsw-form__helper nsw-form__helper--error" id="form-text-3-error-text"><span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>There was an error sending your message. Please try again later.</span>
            </div>
          </form>
          
    </div>
    <div id="externalLinks">
        <div id="connectWithUs">
            <h2 class="feedback-heading">Connect with us</h2>
            <li class="social-link">
                <app-external-link text="Follow us on Twitter" [link]="BEACHWATCH_TWITTER_URL"></app-external-link>
            </li>
            <li class="social-link">
                <app-external-link text="Like us on Facebook" [link]="BEACHWATCH_FACEBOOK_URL"></app-external-link> 
            </li>
        </div>
		<div id="connectWithUs">
            <h2 class="feedback-heading">Media enquiries</h2>
			<div style="padding-bottom:16px;"></div>			
            <span>For any media enquiries concerning the Beachwatch Program please email <a [href]="MEDIA_ENQUIRIES_MAILTO_URL" target="_blank">{{MEDIA_ENQUIRIES_EMAIL_ADDRESS}}</a>.</span>
			<div style="padding-bottom:16px;"></div>
			<span>For further information please refer to  
                <app-external-link text="Public Affairs" [link]="MEDIA_ENQURIES_URL"></app-external-link>.
            </span>
        </div>
        <div id="seenPollution">
            <h2 class="feedback-heading">Have you seen pollution?</h2>
            <div style="padding-bottom:16px;"></div>
            <span>To report pollution at a swim site please contact the 
                <app-external-link text="EPA Environment line" [link]="EPA_ENVIRONMENT_LINE_URL"></app-external-link>
                at any time.
            </span>
        </div>
        <div id="algalBloom">
            <h2 class="feedback-heading">Have you spotted an algal bloom?</h2>
            <div style="padding-bottom:16px;"></div>
            <span>Report suspected algal blooms to 
                <app-external-link text="Water New South Wales" [link]="REPORT_ALGAL_BLOOMS_URL"></app-external-link>.
            </span>
        </div>
    </div>

</div>
